import { createAction } from '@reduxjs/toolkit';

export const resetAppState = createAction('app/reset');


